import React from 'react';

import { CaseSchemaVersionProvider } from '@/components/fields/context';

interface CaseDetailsShellProps {
  schemaVersion: string | undefined;
  breadcrumb: React.ReactNode;
  headerActions: React.ReactNode;
  children: React.ReactNode;
}

/**
 * The root every DefaultCaseDetailsPage state renders — loading, error and loaded.
 *
 * One root type, with the breadcrumb and header actions in fixed slots, lets React keep
 * the header mounted when the page leaves the loading state. When the loading state
 * returned a bare fragment and the loaded state a CaseSchemaVersionProvider, the whole
 * header remounted on load, and a menu opened while the page was loading (the AI Call
 * status dropdown) closed itself.
 */
export const CaseDetailsShell: React.FC<CaseDetailsShellProps> = ({
  schemaVersion,
  breadcrumb,
  headerActions,
  children,
}) => (
  <CaseSchemaVersionProvider schemaVersion={schemaVersion}>
    {breadcrumb}
    {headerActions}
    {children}
  </CaseSchemaVersionProvider>
);
